//============================================================================
// Name        : ReceptionLabelsDetected.tsx
// Purpose     : Implement reception labels detected dialog
// Created     : 2019-11-05
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import React, {RefObject} from "react";

const content = css({
    backgroundColor: "#59b86e",
    color: "white"
});

interface IReceptionLabelsDetectedProps {
    show: boolean;
    callback: () => void;
}

interface IReceptionLabelsDetectedState {
    hidden: boolean;
    shown: boolean;
}

export default class ReceptionLabelsDetected extends React.Component<IReceptionLabelsDetectedProps, IReceptionLabelsDetectedState> {
    continueBtn: RefObject<HTMLButtonElement>;

    constructor(props: IReceptionLabelsDetectedProps) {
        super(props);

        this.continueBtn = React.createRef();
        this.state = {
            hidden: false,
            shown: false
        };
    }

    componentDidUpdate(prevProps: Readonly<IReceptionLabelsDetectedProps>, prevState: Readonly<IReceptionLabelsDetectedState>, snapshot?: any): void {
        this.continueBtn.current.focus();
    }

    getClassName = () => {
        return (this.props.show || this.state.shown) && !this.state.hidden ? "modal show" : "modal fade";
    }

    onContinue = () => {
        this.props.callback();
        this.hide();
    }

    hide = () => {
        this.setState({
            hidden: true,
            shown: false
        });
    }

    onKeyPress = (event) => {
        if (event.key == "Enter") {
            this.onContinue();
        }
    }

    reset() {
        this.setState({ hidden: false });
    }

    render() {
        return (
            <div className={this.getClassName()} tabIndex={-1} role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content" css={content}>
                        <div className="modal-header">
                            <h1 className="modal-title">Information</h1>
                        </div>
                        <div className="modal-body">
                            <div css={{ textAlign: "center", color: "#ffffff", fontSize: 20, fontWeight: "bold" }}>
                                INVENTORY IS NOW UPDATED, PLEASE ATTACH TAG(S) TO RECEIVED ITEM(S)
                            </div>
                        </div>
                        <div className="modal-footer" css={{ padding: "15px" }}>
                            <button ref={this.continueBtn} onClick={this.onContinue} onKeyPress={this.onKeyPress} className="man-btn">Continue</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
